import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingOverlayService {
  private readonly visibleSignal = signal(false);
  private readonly messageSignal = signal('');

  readonly visible = computed(() => this.visibleSignal());
  readonly message = computed(() => this.messageSignal());

  show(message: string): void {
    this.messageSignal.set(message);
    this.visibleSignal.set(true);
  }

  hide(): void {
    this.visibleSignal.set(false);
    this.messageSignal.set('');
  }
}
